import React, { Component } from 'react';
import OtpInput from 'react-otp-input';

import { PaletteColors } from 'styles/themeOptions';

export default class PinCode extends Component {
    state = { otp: '' };

    handleChange = (otp) => {
        this.setState({ otp })
        if (otp.length === 5) {
            this.props.onSubmit(otp)
            this.setState({ otp: '' })
        } else {
            this.setState({ otp })
        }
    };


    render() {
        return (
            <OtpInput
                value={this.state.otp}
                onChange={this.handleChange}
                containerStyle={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                inputStyle={{
                    width: '3rem',
                    height: '3rem',
                    margin: '0.51rem',
                    fontSize: '2rem',
                    backgroundColor: 'transparent',
                    borderColor: PaletteColors.light,
                    borderWidth: '0 0 .7rem 0',
                    color: PaletteColors.white,
                    borderRadius: '0 0 .5rem .5rem',
                }}
                isInputNum={true}
                numInputs={5}
                separator={<span>-</span>}
            />
        );
    }
}